<template>
  <div class="app-inner">
    <el-button type="primary" style="margin: 10px 0" @click="save">保存</el-button>
    <el-calendar v-model="value">
      <template #dateCell={date}>
        <div>{{date | getDay}}</div>
        <div @click="changeRestDay(date)" :class="{'rest-day': isRestDay(date)==='休息日'}">{{isRestDay(date)}}</div>
      </template>
    </el-calendar>
  </div>
</template>

<script>
import moment from 'moment'
import { query, batchUpdate } from '@/api/calendarController'
export default {
  data () {
    return {
      value: '',
      month: '',
      RestList: []
    }
  },
  filters: {
    getDay (value) {
      return value ? moment(value).format('DD') : ''
    }
  },
  methods: {
    // 获取休息日
    getRestDay () {
      if (!this.month) return
      this.RestList = []
      query({
        startTime: `${moment(this.month).format('YYYY-MM-DD')} 00:00:00`,
        endTime: `${moment(this.month).subtract('month', -1).format('YYYY-MM-DD')} 00:00:00`,
        pageSize: 100
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.RestList = [].concat(result.records)
      })
    },
    // 判断工作类型
    isRestDay (date) {
      let valMonth = moment(this.value || new Date()).format('YYYY-MM')
      let newMonth = moment(date).format('YYYY-MM')
      if (valMonth !== newMonth) {
        return '-'
      }
      let newDay = moment(date).format('YYYY-MM-DD')
      let day = this.RestList.find((item) => item.calendarDate === newDay)
      if (day && day.type === 0) {
        return '休息日'
      }
      return '工作日'
    },
    // 改变工作类型
    changeRestDay (date) {
      let data = this.isRestDay(date)
      switch (data) {
        case '-':
          break
        case '休息日': case '工作日':
          this.RestList = this.RestList.map((item) => {
            if (item.calendarDate === moment(date).format('YYYY-MM-DD')) {
              item.type = item.type === 0 ? 1 : 0
            }
            return item
          })
          break
      }
    },
    // 保存
    save () {
      let RestList = this.RestList.map(item => {
        return {
          id: item.id,
          type: item.type
        }
      })
      batchUpdate(RestList).then(res => {
        console.log(res)
      })
    }
  },
  watch: {
    value: {
      handler (value) {
        this.month = moment(value || new Date()).format('YYYY-MM')
      },
      immediate: true
    },
    month: {
      handler () {
        this.getRestDay()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.rest-day {
  color: red;
}
</style>
